import React from "react";

import { UsersListBox } from "../../containers/user";

export const UsersPage = () => {
  return (
    <div>
      <UsersListBox />
    </div>
  );
};
